module.exports = __webpack_public_path__ + "static/img/img-huiys.c0aa7776.png";